'use client'

import Eye from '../../../lib/ui-kit/assets/icons/reeve/banner/eye.svg'
import Unlock from '../../../lib/ui-kit/assets/icons/reeve/banner/unlock.svg'

export const SectionBanner = () => {
  return (
    <section className="m-auto flex flex-col items-center justify-center gap-x-2 gap-y-2 bg-[#EFEDE5] px-6 py-12 xl:flex-row xl:px-10 xl:py-24 2xl:py-40">
      <div className="flex flex-row items-center gap-x-2">
        <div className="rounded-xl bg-reeve-purple px-6 py-4 text-[3rem] font-normal leading-[3.5rem] text-reeve-primary 2xl:text-[4rem] 2xl:leading-[4.5rem]">
          Unlock
        </div>
        <div className="rounded-full bg-reeve-blue p-3 2xl:p-5">
          <Unlock className="h-16 w-16 fill-reeve-primary" />
        </div>
      </div>
      <div className="rounded-xl bg-reeve-orange px-6 py-4 text-[3rem] font-normal leading-[3.5rem] text-reeve-primary 2xl:text-[4rem] 2xl:leading-[4.5rem]">
        Financial
      </div>
      <div className="flex flex-row-reverse items-center gap-x-2 xl:flex-row">
        <div className="rounded-xl bg-reeve-yellow px-6 py-4 text-[3rem] font-normal leading-[3.5rem] text-reeve-primary 2xl:text-[4rem] 2xl:leading-[4.5rem]">
          Clarity
        </div>
        <div className="rounded-full bg-reeve-green p-3 2xl:p-5">
          <Eye className="h-16 w-16 fill-reeve-primary" />
        </div>
      </div>
    </section>
  )
}
